import type { ProductQuantityMap } from '../../usage/useBilling'

export function computeTotalCost(productQuantityMap: ProductQuantityMap) {
  return Object.values(productQuantityMap).reduce(
    (acc, { quantity, productDetails }) => acc + (quantity * (productDetails.price.unit_amount ?? 0)) / 100,
    0
  )
}
